export default __webpack_public_path__ + "static/media/코아.5edbbe54.svg";